/** @file This file defines constants for our Vue app. */
/** The message to remind users about a unique password. */
export const PASSWORD_UNIQUE_MESSAGE = 'Please make sure you use a unique password, and at least different from the password you use for your LMS.';
/** Indicates that a value has not yet been set (eg in a model cache). */
export const UNSET_SENTINEL = Symbol('UNSET_SENTINEL');
/** The initial amount of courses to load. */
export const INITIAL_COURSES_AMOUNT = 100;
/**
 * The max amount of extra courses that should be loaded per query when we reach the end of the
 * infinite scroll list, or when looking for specific course.
 */
export const MAX_COURSES_PER_LOAD = 2500;
/**
 * Line number for comments used when the file that is commented on has no concept of individual
 * lines (examples being images, pdfs, empty files or files that cannot be rendered).
 */
export const DEFAULT_LINE_NUMBER = 0;
/** The size breakpoints for the app. */
export const BREAKPOINTS = Object.freeze({
    smallWidth: 628,
    mediumWidth: 768,
    largeWidth: 992,
    xlargeWidth: 1200,
});
